import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { DashboardHeadCompactComponent } from './dashboard-head-compact/dashboard-head-compact.component';
import { DashboardHeadComponent } from './dashboard-head/dashboard-head.component';
import { LeftNavFlyoutMenuComponent } from './left-nav-flyout-menu/left-nav-flyout-menu.component';
import { LeftNavRailItemComponent } from './left-nav-rail-item/left-nav-rail-item.component';
import { LeftNavTreeItemComponent } from './left-nav-tree-item/left-nav-tree-item.component';
import { SideNavItemProComponent } from './side-nav-item-pro/side-nav-item-pro.component';
import { TopNavAlertsItemComponent } from './top-nav-alerts-item/top-nav-alerts-item.component';
import { TopNavAlertsComponent } from './top-nav-alerts/top-nav-alerts.component';
import { TopNavDocsComponent } from './top-nav-docs/top-nav-docs.component';
import { TopNavMessagesItemComponent } from './top-nav-messages-item/top-nav-messages-item.component';
import { TopNavMessagesComponent } from './top-nav-messages/top-nav-messages.component';
import { TopNavSearchComponent } from './top-nav-search/top-nav-search.component';
import { TopNavUserComponent } from './top-nav-user/top-nav-user.component';

export const components = [
    SideNavItemProComponent,
    BreadcrumbsComponent,
    DashboardHeadComponent,
    TopNavUserComponent,
    TopNavAlertsComponent,
    TopNavMessagesComponent,
    TopNavSearchComponent,
    TopNavMessagesItemComponent,
    TopNavAlertsItemComponent,
    TopNavDocsComponent,
    DashboardHeadCompactComponent,
    LeftNavRailItemComponent,
    LeftNavFlyoutMenuComponent,
    LeftNavTreeItemComponent,
];

export * from './side-nav-item-pro/side-nav-item-pro.component';
export * from './breadcrumbs/breadcrumbs.component';
export * from './dashboard-head/dashboard-head.component';
export * from './top-nav-user/top-nav-user.component';
export * from './top-nav-alerts/top-nav-alerts.component';
export * from './top-nav-messages/top-nav-messages.component';
export * from './top-nav-search/top-nav-search.component';
export * from './top-nav-messages-item/top-nav-messages-item.component';
export * from './top-nav-alerts-item/top-nav-alerts-item.component';
export * from './top-nav-docs/top-nav-docs.component';
export * from './dashboard-head-compact/dashboard-head-compact.component';
export * from './left-nav-rail-item/left-nav-rail-item.component';
export * from './left-nav-flyout-menu/left-nav-flyout-menu.component';
export * from './left-nav-tree-item/left-nav-tree-item.component';
